import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'schedules.classtivity-scheduler.add-class-modal.title',
    defaultMessage: 'Add a new class',
  },
  className: {
    id: 'schedules.classtivity-scheduler.add-class-modal.class-name',
    defaultMessage: 'Name',
  },
  classDescription: {
    id: 'schedules.classtivity-scheduler.add-class-modal.class-description',
    defaultMessage: 'Description',
  },
});
